import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { mediaManagerSortChanged } from '@wix/bi-logger-media-data/v2';
import { MenuRow, MenuTitle, WixIcons } from '../../../../components/common';
import { Sort } from '../../../../constants/Sort';
import { bi } from '../../../../services/loggers/bi';
import { IOuter } from './SortSwitcherMenu.types';

export const SortSwitcherMenu: FC<IOuter> = ({ sort, onSortChange, tabName }) => {
  const changeSortLastModified = useCallback(() => {
    const newSort = Sort.LastModified;
    onSortChange(newSort);
    bi.logger().report(
      mediaManagerSortChanged({
        previousSelection: sort,
        target: newSort,
        tabName,
      }),
    );
  }, [sort, onSortChange, tabName]);

  const changeSortOldestFirst = useCallback(() => {
    const newSort = Sort.OldestFirst;
    onSortChange(newSort);
    bi.logger().report(
      mediaManagerSortChanged({
        previousSelection: sort,
        target: newSort,
        tabName,
      }),
    );
  }, [sort, onSortChange, tabName]);

  const changeSortAZ = useCallback(() => {
    const newSort = Sort.AZ;
    onSortChange(newSort);
    bi.logger().report(
      mediaManagerSortChanged({
        previousSelection: sort,
        target: newSort,
        tabName,
      }),
    );
  }, [sort, onSortChange, tabName]);

  const changeSortZA = useCallback(() => {
    const newSort = Sort.ZA;
    onSortChange(newSort);
    bi.logger().report(
      mediaManagerSortChanged({
        previousSelection: sort,
        target: newSort,
        tabName,
      }),
    );
  }, [sort, onSortChange, tabName]);

  return (
    <>
      <MenuTitle text={<FormattedMessage id="sort-switcher.menu-title.last-modified" />} />
      <MenuRow
        icon={<WixIcons.SortDescendingSmall />}
        text={<FormattedMessage id="sort-switcher.menu-item.descending" />}
        active={sort === Sort.LastModified}
        onClick={changeSortLastModified}
        dataHook="sort-by-last-modified"
      />
      <MenuRow
        icon={<WixIcons.SortAscendingSmall />}
        text={<FormattedMessage id="sort-switcher.menu-item.ascending" />}
        active={sort === Sort.OldestFirst}
        onClick={changeSortOldestFirst}
        dataHook="sort-by-oldest-first"
      />

      <MenuTitle text={<FormattedMessage id="sort-switcher.menu-title.name" />} />
      <MenuRow
        icon={<WixIcons.SortAZSmall />}
        text={<FormattedMessage id="sort-switcher.menu-item.az" />}
        active={sort === Sort.AZ}
        onClick={changeSortAZ}
        dataHook="sort-by-az"
      />
      <MenuRow
        icon={<WixIcons.SortZASmall />}
        text={<FormattedMessage id="sort-switcher.menu-item.za" />}
        active={sort === Sort.ZA}
        onClick={changeSortZA}
        dataHook="sort-by-za"
      />
    </>
  );
};
